import React, { useState } from 'react';
import { Input } from 'antd';
import { concatClasses } from '@blink/components/src/utils';

interface InputNumericProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    errors?: boolean;
    maxDecimals?: number;
    length?: number;
    suffix?: string;
}

export const InputNumeric: React.FC<InputNumericProps> = ({
    value,
    onChange,
    placeholder,
    className,
    errors,
    maxDecimals = 2,
    length = 31,
    suffix = '',
}) => {
    const [focused, setFocused] = useState(false);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value.replace(suffix, '');

        const integerPart = inputValue.split('.')[0];
        const decimalRegex = new RegExp(`^\\d*\\.?\\d{0,${maxDecimals}}$`);
        if (decimalRegex.test(inputValue) && integerPart.length <= length) {
            onChange(inputValue);
        }
    };

    const handleFocus = () => {
        setFocused(true);
    };

    const handleBlur = () => {
        setFocused(false);
    };

    const displayValue = focused || !suffix ? value : `${value}${suffix}`;

    return (
        <Input
            value={displayValue}
            onChange={handleInputChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={placeholder || '0.00'}
            className={concatClasses(className!, errors ? 'error' : '')}
        />
    );
};
